import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import {
  ifAuthenticated,
  ifAdmin,
  ifAnonymous,
  ifFullyRegistered,
} from "@/router/utils";
import Forbidden from "@/views/Forbidden";
import NotFound from "@/views/NotFound.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/reset_password/:token",
    name: "ResetPassword",
    props: {
      reset_password: true,
    },
    component: Home,
  },
  {
    path: "/newsletter_subscribe/:token",
    name: "NewsletterOptin",
    props: {
      newsletter_optin: true,
    },
    component: Home,
  },
  {
    path: "/forgot_password",
    name: "ForgotPassword",
    props: {
      forgot_password: true,
    },
    component: Home,
  },
  {
    path: "/preregister_confirm/:token",
    name: "PreregisterConfirm",
    props: {
      pre_confirmed: true,
    },
    component: Home,
  },
  {
    path: "/register_confirm/:token",
    name: "RegisterConfirm",
    props: {
      confirmed: true,
    },
    component: Home,
  },
  {
    path: "/admin/user",
    name: "AdminUser",
    beforeEnter: ifAdmin,
    component: () =>
      import(/* webpackChunkName: "admin-user" */ "../views/AdminUser.vue"),
  },
  {
    path: "/contact",
    name: "ContactPerson",
    props: {
      reset_password: true,
    },
    component: () =>
      import(
        /* webpackChunkName: "contact-person" */ "../views/ContactPerson.vue"
      ),
  },
  {
    path: "/login",
    name: "Login",
    beforeEnter: ifAnonymous,
    props: {
      login: true,
    },
    component: Home,
  },
  {
    path: "/benchmarks",
    name: "Benchmarks",
    beforeEnter: ifFullyRegistered,
    component: () =>
      import(/* webpackChunkName: "benchmarks" */ "../views/Benchmarks.vue"),
  },
  {
    path: "/register",
    name: "Registrierung",
    component: () =>
      import(/* webpackChunkName: "register" */ "../views/Register.vue"),
  },
  {
    path: "/profile",
    name: "Profile",
    beforeEnter: ifAuthenticated,
    component: () =>
      import(/* webpackChunkName: "profile" */ "../views/Profile.vue"),
  },

  {
    path: "/",
    name: "Home",
    beforeEnter: ifAuthenticated,
    component: Home,
  },

  {
    path: "/forbidden",
    name: "Forbidden",
    component: Forbidden,
  },
  {
    // catch all 404 - define at the very end
    path: "*",
    component: NotFound,
  },
];

const router = new VueRouter({
  //mode: "history",
  mode: "hash",
  base: "/app/",
  routes,
});

export default router;
